import useCurrentUser from '~/hooks/useCurrentUser'

import { canUseFilter } from './filter-access'

export function useFilterAccess() {
  const currentUser = useCurrentUser()
  const allowedFilterFields = currentUser ? currentUser.allowedFilterFields : []

  return {
    allowedFilterFields,
    isFilterAllowed(field: string): boolean {
      return canUseFilter(allowedFilterFields, field)
    },
  }
}
